import React, { FC, ReactNode } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import tooltipBoosterHoc, {
  TooltipBoosterHocProps
} from 'website/components/Tooltip/tooltipBooster';
import { DataState } from 'website/reducers/data';
import { getOpinionForEntity } from 'website/reducers/data/helper';

type PropsFromRedux = ConnectedProps<typeof connector>;

type ComponentProps = TooltipBoosterHocProps &
  PropsFromRedux & {
    hasOpinion: boolean;
  };

let hideOpinionBooster = false;

const mapStateToProps = (
  state: { data: DataState },
  ownProps: { entityId: string }
) => {
  const opinion = getOpinionForEntity(ownProps.entityId, state.data);
  return {
    hasOpinion: !!(opinion?.rating || opinion?.review)
  };
};

const connector = connect(mapStateToProps);

const opinionBoosterHoc = (
  WrappedComponent: FC<Omit<ComponentProps, 'hasOpinion'>>,
  anchor: Element,
  boosterClass: string,
  BoosterContent: ReactNode
) =>
  connector(({ hasOpinion = false, ...rest }: ComponentProps) => {
    if (hideOpinionBooster || hasOpinion) {
      hideOpinionBooster = true;
      return <WrappedComponent {...rest} />;
    }

    const TooltipBoosterComponent = tooltipBoosterHoc(
      WrappedComponent,
      anchor,
      boosterClass,
      BoosterContent
    );

    return <TooltipBoosterComponent {...rest} />;
  });

export default opinionBoosterHoc;
